import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import _ from "lodash";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* unbanUser(action) {
  const { userId: id } = action.payload;
  const { success, data, error } = yield* makeRequest.post(`/users/${id}/unban`);
  if (success && data) {
    const user = keysToCamelCase(_.clone(data.body));
    yield put(
      actions.newSuccessEvent({
        message: messages.UNBAN_USER_SUCCESS,
      }),
    );
    yield put(actions.setUserDetails(user));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_UNBANNING_USER,
    });
  }

  return null;
}

export default unbanUser;
